/**
 * To maps properties of each possible filter
 * @description: Below constant maps each filter with its properties. We can directly access all possible filter and its
 * properties from a central place.
 */
export const DateType: any = {
  'TEXT': 'TEXT',
  'DATE': 'DATE',
  'DATE_RANGE': 'DATE_RANGE',
  'NUMBER': 'NUMBER',
  'SEARCH': 'SEARCH',
  'SELECT': 'SELECT',
  'MULISELECT': 'MULISELECT',
  'AUTOCOMPLETE': 'AUTOCOMPLETE',
  'DATE_DROPDOWN': 'DATE_DROPDOWN'
}


export const FilterMapping: any = {
  'ModuleList': {
    label: "Module",
    apiKey: "moduleList",
    urlKey: "ModuleList",
    defaultValue: "",
    valueLabel: "name",
    valueKey: "id",
    order: 1,
    dataType: DateType.MULISELECT
  },
  'Subject': {
    label: "Subject",
    apiKey: "subjectList",
    urlKey: "SubjectList",
    defaultValue: "",
    valueLabel: "name",
    valueKey: "id",
    order: 2,
    dataType: DateType.AUTOCOMPLETE
  },
  'DoctypeList': {
    label: "Document Type",
    apiKey: "documentTypeList",
    urlKey: "DoctypeList",
    defaultValue: "",
    valueLabel: "name",
    valueKey: "id",
    order: 3,
    dataType: DateType.MULISELECT
  },
  'CategoryList': {
    label: "Category",
    apiKey: "categoryList",
    urlKey: "CategoryList",
    defaultValue: "",
    valueLabel: "name",
    valueKey: "id",
    order: 4,
    dataType: DateType.MULISELECT
  },
  'GlobaltopiList': {
    label: "Global Topic",
    apiKey: "globalTopicsList",
    urlKey: "GlobaltopiList",
    defaultValue: "",
    valueLabel: "name",
    valueKey: "id",
    order: 5,
    dataType: DateType.MULISELECT
  },
  'TopicList': {
    label: "Topic",
    apiKey: "topicsList",
    urlKey: "TopicList",
    defaultValue: "",
    valueLabel: "name",
    valueKey: "id",
    order: 6,
    dataType: DateType.MULISELECT
  },
  'ActList/RuleList': {
    label: "Act/Rule",
    apiKey: "actList",
    urlKey: "ActList",
    defaultValue: "",
    valueLabel: "name",
    valueKey: "id",
    order: 7,
    dataType: DateType.SELECT
  },
  'SectionList': {
    label: "Section/Rule",
    apiKey: "sectionList",
    urlKey: "SectionList",
    defaultValue: "",
    valueLabel: "name",
    valueKey: "id",
    order: 8,
    dataType: DateType.MULISELECT
  },
  'RuleList': {
    label: "Rule",
    apiKey: "ruleList",
    urlKey: "RuleList",
    defaultValue: "",
    valueLabel: "name",
    valueKey: "id",
    order: 9,
    dataType: DateType.SELECT
  },
  'InfavourList': {
    label: "In Favour Of",
    apiKey: "infavourOfList",
    urlKey: "InfavourList",
    defaultValue: "",
    valueLabel: "name",
    valueKey: "id",
    order: 10,
    dataType: DateType.MULISELECT
  },
  'CourtList': {
    label: "Court",
    apiKey: "courtList",
    urlKey: "CourtList",
    defaultValue: "",
    valueLabel: "name",
    valueKey: "id",
    order: 12,
    dataType: DateType.MULISELECT
  },
  'BenchList': {
    label: "Bench",
    apiKey: "benchList",
    urlKey: "BenchList",
    defaultValue: "",
    valueLabel: "name",
    valueKey: "id",
    order: 11,
    dataType: DateType.MULISELECT
  },
  'YearList': {
    label: "Year",
    apiKey: "yearList",
    urlKey: "YearList",
    defaultValue: "",
    valueLabel: "name",
    valueKey: "id",
    order: 13,
    dataType: DateType.MULISELECT
  },
  'LevelList': {
    label: "Level",
    apiKey: "levelList",
    urlKey: "LevelList",
    defaultValue: "",
    valueLabel: "name",
    valueKey: "id",
    order: 14,
    dataType: DateType.MULISELECT
  },
  'AuthorList': {
    label: "Authors/Speakers",
    apiKey: "authorSpeakerList",
    urlKey: "AuthorList",
    defaultValue: "",
    valueLabel: "name",
    valueKey: "id",
    order: 15,
    dataType: DateType.MULISELECT
  },
  'FocusAreaList': {
    label: "Focus Area",
    apiKey: "focusArea",
    urlKey: "FocusAreaList",
    defaultValue: "",
    valueLabel: "name",
    valueKey: "id",
    order: 16,
    dataType: DateType.MULISELECT
  }
}

export const TabMapping: any = {
  'SEARCH': ['search'],
  'CASELAWS': ['111050000000000060'],
  'ACTRULES': ['111050000000000064'],
  'READ': ['24'],
  'ARTCOMM': ["111050000000000051", "111050000000000056"],
  'CIRNOTTIF': ['111050000000000057'],
  'VIDEO': ['event_learning_dev'],
  'FORMS': ['111050000000000026'],
  'TARIFF': ['111050000000017179'],
  'OTHERS': ["24", "event_learning_dev_2024new", "111050000000000060", "111050000000000064", "111050000000000051", "111050000000000056", "111050000000000057", "111050000000000026", "111050000000017179"],
  'LATEST': []
  // 'LATEST': ["111050000000000060","111050000000000057","111050000000000051","111050000000000056","111050000000000064","111050000000000059","111050000000009177","111050000000000026","111050000000000054","111050000000011660","111050000000017823","111050000000011665","111050000000000033","111050000000011664","111050000000000063","111050000000000028","111050000000000050","111050000000005002","111050000000017331","111050000000000041","111050000000011406","111050000000016120","5","24","2","3","7","26","1","17","15"],
}

export const TabMappingName: any = {
  'SEARCH': '',
  'CASELAWS': 'CaseLaws',
  'ACTRULES': 'Acts & Rules',
  'READ': 'Read',
  'ARTCOMM': 'Articles & Commentaries',
  'CIRNOTTIF': 'Circulars & Notifications',
  'VIDEO': 'Video',
  'FORMS': 'Forms',
  'TARIFF': 'Tariff',
  'OTHERS': 'Others',
  'LATEST': 'Latest'
}
export const TabMoreMapping: any = [TabMapping.SEARCH, TabMapping.CASELAWS, TabMapping.ARTCOMM, TabMapping.CIRNOTTIF, TabMapping.VIDEO, TabMapping.OTHERS, TabMapping.LATEST]

export const MoreFilterMapping: any = {
  'partyList': {
    label: "Party Name",
    apiKey: "partyList",
    searchKey: "nameofparty",
    urlKey: "partyList",
    defaultValue: "",
    valueLabel: "name",
    valueKey: "id",
    order: 1,
    dataType: DateType.AUTOCOMPLETE,
    tabMapping: [
      TabMapping.SEARCH,
      TabMapping.CASELAWS
    ]
  },
  'judgeList': {
    label: "Judge Name",
    apiKey: "judgeList",
    searchKey: "judgename",
    urlKey: "judgeList",
    defaultValue: "",
    valueLabel: "name",
    valueKey: "id",
    order: 2,
    dataType: DateType.AUTOCOMPLETE,
    tabMapping: [
      TabMapping.SEARCH,
      TabMapping.CASELAWS
    ]
  },
  'counselList': {
    label: "Counsel Name",
    apiKey: "counselList",
    searchKey: "counselname",
    urlKey: "counselList",
    defaultValue: "",
    valueLabel: "name",
    valueKey: "id",
    order: 3,
    dataType: DateType.AUTOCOMPLETE,
    tabMapping: [
      TabMapping.SEARCH,
      TabMapping.CASELAWS
    ]
  },
  'dateValue': {
    label: "Duration",
    apiKey: "dateValue",
    urlKey: "dateValue",
    defaultValue: "",
    valueLabel: "name",
    valueKey: "id",
    order: 4,
    dataType: DateType.DATE_DROPDOWN,
    tabMapping: [
      TabMapping.LATEST
    ],
    keyChild: ['fromDate', 'toDate']
  },
  'fromDate': {
    label: "Date Range",
    placeHolder:"From",
    apiKey: "fromDate",
    urlKey: "fromDate",
    defaultValue: "",
    valueLabel: "name",
    valueKey: "id",
    order: 5,
    dataType: DateType.DATE,
    tabMapping: [
      TabMapping.SEARCH,
      TabMapping.CASELAWS,
      TabMapping.ARTCOMM,
      TabMapping.CIRNOTTIF,
      TabMapping.VIDEO,
      TabMapping.OTHERS
    ],
  },
  'toDate': {
    label: "",
    placeHolder:"To",
    apiKey: "toDate",
    urlKey: "toDate",
    defaultValue: "",
    valueLabel: "name",
    valueKey: "id",
    order: 6,
    dataType: DateType.DATE,
    tabMapping: [
      TabMapping.SEARCH,
      TabMapping.CASELAWS,
      TabMapping.ARTCOMM,
      TabMapping.CIRNOTTIF,
      TabMapping.VIDEO,
      TabMapping.OTHERS
    ]
  },
  'JournalList': {
    label: "Journal",
    apiKey: "journalList",
    urlKey: "journalList",
    defaultValue: "",
    valueLabel: "name",
    valueKey: "id",
    order: 7,
    dataType: DateType.SELECT,
    tabMapping: [
      TabMapping.SEARCH,
      TabMapping.CASELAWS,
      TabMapping.ARTCOMM,
      TabMapping.LATEST
    ],
  },
  'volume': {
    label: "Volume",
    apiKey: "volume",
    urlKey: "volume",
    defaultValue: "",
    valueLabel: "name",
    valueKey: "id",
    order: 8,
    dataType: DateType.TEXT,
    tabMapping: [
      TabMapping.SEARCH,
      TabMapping.CASELAWS,
      TabMapping.ARTCOMM,
      TabMapping.LATEST
    ]
  },
  'pageNo': {
    label: "Page No",
    apiKey: "pageNo",
    urlKey: "pageNo",
    defaultValue: "",
    valueLabel: "name",
    valueKey: "id",
    order: 9,
    dataType: DateType.TEXT,
    tabMapping: [
      TabMapping.SEARCH,
      TabMapping.CASELAWS,
      TabMapping.ARTCOMM,
      TabMapping.LATEST
    ]
  }
}

export const DurationFilterOptions = [
  {
    label: 'Last 3 Days',
    value: 3
  },
  {
    label: 'Last 7 Days',
    value: 7
  },
  {
    label: 'Last 15 Days',
    value: 15
  },
  {
    label: 'Last 30 Days',
    value: 30
  },
  {
    label: 'Custom Range',
    value: 1
  }
];

export enum ResearchListSortOrder {
  ASC = 0,
  DESC,
}

export const SortConst = {
  RELEVANCE_WISE: 'relevance',
  ALPHA_NUMERIC_WISE: 'alphanumericwise',
  CHAPTER_CWISE: 'chapterwise',
  NAME_WISE: 'namewise',
  DATE_WISE: 'datewise',
  COURT_WISE: 'courtwise',
  CITIATON_WISE: 'citationwise'
}

export const SortByOption: any = [
  {
    label: 'Relevance',
    value: SortConst.RELEVANCE_WISE,
    sortOrder: ResearchListSortOrder.DESC,
    tabMapping: [
      TabMapping.SEARCH, 
      TabMapping.CASELAWS, 
      TabMapping.ARTCOMM, 
      TabMapping.CIRNOTTIF, 
      TabMapping.VIDEO,
      TabMapping.READ,
      TabMapping.FORMS,    
      TabMapping.OTHERS, 
      TabMapping.LATEST,
      TabMapping.TARIFF,
      TabMapping.ACTRULES,
    ]
  },
  {
    label: 'AlphaNumeric',
    value: SortConst.ALPHA_NUMERIC_WISE,
    sortOrder: ResearchListSortOrder.DESC,
    tabMapping: [
      TabMapping.ARTCOMM, 
      TabMapping.CIRNOTTIF, 
      TabMapping.LATEST,
      TabMapping.FORMS, 
      TabMapping.ACTRULES,
      TabMapping.TARIFF,
    ]
  },
  {
    label: 'Chapter',
    value: SortConst.CHAPTER_CWISE,
    sortOrder: ResearchListSortOrder.DESC,
    tabMapping: [
      TabMapping.TARIFF 
    ]
  },
  {
    label: 'Name',
    value: SortConst.NAME_WISE,
    sortOrder: ResearchListSortOrder.DESC,
    tabMapping: [
      TabMapping.CASELAWS, 
      // TabMapping.READ
    ]
  },
  {
    label: 'Date',
    value: SortConst.DATE_WISE,
    sortOrder: ResearchListSortOrder.DESC,
    tabMapping: [
      TabMapping.SEARCH, 
      TabMapping.CASELAWS, 
      TabMapping.ARTCOMM, 
      TabMapping.CIRNOTTIF, 
      TabMapping.VIDEO, 
      TabMapping.OTHERS, 
      TabMapping.LATEST
    ]
  },
  {
    label: 'Court',
    value: SortConst.COURT_WISE,
    sortOrder: ResearchListSortOrder.DESC,
    tabMapping: [
      TabMapping.CASELAWS, 
    ]
  },
  {
    label: 'Citation',
    value: SortConst.CITIATON_WISE,
    sortOrder: ResearchListSortOrder.DESC,
    tabMapping: [
      TabMapping.CASELAWS, 
    ]
  },
]

export const SortListOrder: any = [
  {
    label: "<i class='pi pi-sort-amount-down-alt'></i>",
    value: ResearchListSortOrder.ASC,
    title: 'Ascending',
  },
  {
    label: "<i class='pi pi-sort-amount-up'></i>",
    value: ResearchListSortOrder.DESC,
    title: 'Descending',
  },

]

